<div aria-labelledby="totalfunding" class="total-funding-card">
    <div class="amount" data-pw="total-funding" data-qa="total-funding">
      {{ (awardFundingDetails()?.totalFunding| currency:'USD':'symbol':'1.0-0') ?? '-' }}
    </div>
    <p class="amount-label" data-pw="total-funding-label" data-qa="total-funding-label">Total Funding</p>
  </div>
<div class="amount-cards">
  <div id="acm" aria-labelledby="acm" class="amount-card">
    <div class="header">
      <img alt="Amount of Money" height="48" id="acm-img" width="48" [ngSrc]="'../assets/images/div.svg'" />
      <div class="title">
        <h4 aria-level="2" id="acm-title" role="heading">Amount of Money</h4>
        <p id="acm-subtitle">
          {{ programType() === ProgramType.ESA ? 'ESA+' : 'Opportunity Scholarship' }}
        </p>
      </div>
    </div>
    <div class="content">
      <div class="amount-field" data-pw="amount-field-offered" data-qa="amount-field-offered">
        <div class="amount" data-pw="amount-offered" data-qa="amount-offered">
          {{ (awardFundingDetails()?.awardAmountOffered| currency:'USD':'symbol':'1.0-0') ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-offered-label" data-qa="amount-offered-label">Amount Offered </p>
      </div>
      <div class="amount-field" data-pw="amount-field-offer-outstanding" data-qa="amount-field-offer-outstanding">
        <div class="amount" data-pw="offered-outstanding" data-qa="offered-outstanding">
          {{ (awardFundingDetails()?.awardAmountOutstanding | currency:'USD':'symbol':'1.0-0') ?? '-' }}
        </div>
        <p class="amount-label" data-pw="offered-outstanding-label" data-qa="offered-outstanding-label"
          for="offeredOutstanding"> Amount of Offers Outstanding </p>
      </div>
      <div class="amount-field" data-pw="amount-field-remaining-funds" data-qa="amount-field-remaining-funds">
        <div class="amount" data-pw="remaining-funds" data-qa="remaining-funds">
          {{ (awardFundingDetails()?.remainingFunding | currency:'USD':'symbol':'1.0-0') ?? '-' }}
        </div>
        <p class="amount-label" data-pw="remaining-funds-label" data-qa="remaining-funds-label" for="remainingFunds">
          Remaining Funds </p>
      </div>
      <div class="amount-field" data-pw="amount-field-offered2" data-qa="amount-field-offered2">
        <div class="amount" data-pw="amount-accepted" data-qa="amount-accepted">
          {{ (awardFundingDetails()?.awardAmountAccepted | currency:'USD':'symbol':'1.0-0') ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-accepted-label" data-qa="amount-accepted-label"> Amount Accepted </p>
      </div>
    </div>
  </div>
  <div id="acs" aria-labelledby="acs" class="amount-card">
    <div class="header">
      <img alt="Number of Awards Sent" height="48" id="acs-img" width="48" [ngSrc]="'../assets/images/div.svg'" />
      <div class="title">
        <h4 aria-level="2" id="acs-title" role="heading">Number of Awards Sent</h4>
        <p id="acs-subtitle">
          {{ programType() === ProgramType.ESA ? 'ESA+' : 'Opportunity Scholarship' }}
        </p>
      </div>
    </div>
    <div class="content">
      <div class="amount-field" data-pw="amount-field-extended" data-qa="amount-field-extended">
        <div class="amount" data-pw="amount-offered-extended" data-qa="amount-offered-extended">
          {{ (awardFundingDetails()?.awardOffersExtended | number)  ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-offered-extended-label" data-qa="amount-offered-extended-label"> Award
          Offers Extended </p>
      </div>
      <div class="amount-field" data-pw="amount-field-accepted" data-qa="amount-field-accepted">
        <div class="amount" data-pw="amount-offered-accepted" data-qa="amount-offered-accepted">
          {{ (awardFundingDetails()?.awardOffersAccepted | number) ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-offered-accepted-label" data-qa="amount-offered-accepted-label"> Award
          Offers Accepted </p>
      </div>
      <div class="amount-field" data-pw="amount-field-declined" data-qa="amount-field-declined">
        <div class="amount" data-pw="amount-offered-declined" data-qa="amount-offered-declined">
          {{ (awardFundingDetails()?.awardOffersDeclined | number) ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-offered-declined-label" data-qa="amount-offered-declined-label"> Award
          Offers Declined </p>
      </div>
      <div class="amount-field" data-pw="amount-field-outstanding" data-qa="amount-field-outstanding">
        <div class="amount" data-pw="amount-offered-outstanding" data-qa="amount-offered-outstanding">
          {{ (awardFundingDetails()?.awardOffersOutstanding | number) ?? '-' }}
        </div>
        <p class="amount-label" data-pw="amount-offered-outstanding-label" data-qa="amount-offered-outstanding-label">
          Award Offers Outstanding </p>
      </div>
    </div>
  </div>
</div>